<template>
  <div style="width: 100%;">
    <div style="margin-top:20px;width: 100%;"
         class="flexCenter">
      <!-- :style="{'backgroundImage':'url(' + item.url + ')' ,'backgroundPosition':'50%','backgroundSize':index != activeIndex?'cover':'100% 100%' ,'backgroundRepeat': 'no-repeat'}" -->
      <div class="offline_item"
           @mouseenter="mouseover(index)"
           @mouseleave="mouseout"
           v-for="(item,index) in list"
           :key="index">
        <div class="offline_item_top"
             :style="{'backgroundImage': 'url(' + $imgUrl + item.bg + ')','backgroundSize':'100% 100%','backgroundRepeat':'no-repeat'}">
          <div class="title">{{item.title}}</div>
          <div class="content">{{item.fu_title}}</div>
        </div>
        <div class="offline_item_content">
          <img class="dong"
               :style="{'transform':activeIndex==index?'scale(1.5)':''}"
               :src="$imgUrl + item.url"
               alt="">
          <div v-if="activeIndex!=index"
               class="active"></div>
          <div class="text_box">
            <div><span style="font-weight:600">内容：</span> {{item.content}}</div>
            <div style="margin-top:20px"><span style="font-weight:600">参训建议：</span>{{item.proposal}}</div>
          </div>

        </div>
      </div>
    </div>
    <div style="margin-top:20px;width: 100%;"
         class="flexCenter">
      <div class="offline_item"
           @mouseenter="mouseover(index+4)"
           @mouseleave="mouseout"
           v-for="(item,index) in list2"
           :key="index">
        <div class="offline_item_top"
             :style="{'backgroundImage': 'url(' + $imgUrl + item.bg + ')','backgroundSize':'100% 100%','backgroundRepeat':'no-repeat'}">
          <div class="title">{{item.title}}</div>
          <div class="content">{{item.fu_title}}</div>
        </div>
        <div class="offline_item_content">
          <img class="dong"
               :style="{'transform':activeIndex==index+4?'scale(1.5)':''}"
               :src="$imgUrl + item.url"
               alt="">
          <div v-if="activeIndex!=index+4"
               class="active"></div>
          <div class="text_box">
            <div><span style="font-weight:600">内容：</span>{{item.content}}</div>
            <div style="margin-top:20px"><span style="font-weight:600">参训建议：</span>{{item.proposal}}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  data () {
    return {
      activeIndex: -1,
      list: [
        { url: 'RetailTraining/RDK_BJ_img.png', title: '实时热点课', fu_title: '每年开设30余期', content: '热点、难点解读，经典案例剖 析，知识更新升级快', proposal: '不同主题不同人群', bg: 'RetailTraining/RDK_BJ.png' },
        { url: 'RetailTraining/jxy_BJ_img.png', title: '岗位集训营', fu_title: '每年开设6-8期', content: '岗位军训、小班教学、封闭学 习、结业汇报', proposal: '不同主题不同人群', bg: 'RetailTraining/jxy_BJ.png' },
        { url: 'RetailTraining/zy_BJ_img.png', title: '源头厂家对接', fu_title: '每年开设10余期', content: '优质资源、源头自采、价格优 势、性价比高', proposal: '高管、老板、股东', bg: 'RetailTraining/zy_BJ.png' },
        { url: 'RetailTraining/fh_BJ_img.png', title: '零售总裁峰会', fu_title: '每年开设2-3期', content: '行业大咖、优质资源、行业趋 势、资源共享', proposal: '高管、老板、股东', bg: 'RetailTraining/fh_BJ.png' },
      ],
      list2: [
        { url: 'RetailTraining/bg_BJ_img.png', title: '标杆企业参访', fu_title: '每年开设10余期', content: '经验学习、标杆分享、门店参 访、资源对接', proposal: '老板、高管、股东', bg: 'RetailTraining/bg_BJ.png' },
        { url: 'RetailTraining/mc_BJ_img.png', title: '卖场实操课程', fu_title: '每年开设30余期', content: '学练一体、卖场实操、落地作 业、案例拆解', proposal: '不同主题不同人群', bg: 'RetailTraining/mc_BJ.png' },
        { url: 'RetailTraining/sdh_BJ_img.png', title: '零售私董会', fu_title: '每年开设4-5余期', content: '老板圈子、投资、项目、资源商业论道', proposal: '高管、老板、股东', bg: 'RetailTraining/sdh_BJ.png' },
        { url: 'RetailTraining/nx_BJ_img.png', title: '企业内训', fu_title: '个性化定制，主题多元', content: '全员培训、需求定制、解决方 案、辅导落地', proposal: '企业全员同成长', bg: 'RetailTraining/nx_BJ.png' },
      ]
    }
  },
  methods: {
    mouseover (e) {
      console.log(e)
      this.activeIndex = e
    },
    mouseout () {
      this.activeIndex = -1
    }
  }
}
</script>
<style lang="less" scoped>
// .active {
//   flex: 2;
//   margin-right: 20px;
//   border-radius: 20px;
//   background-color: #fff;
//   height: 400px;
// }
.offline_item {
  flex: 1;
  // width: 24%;
  margin-right: 40px;
  border-radius: 10px;
  // padding: 20px;
  box-sizing: border-box;
  background-color: #fff;
  height: 376px;
  transition: all 0.3s ease-in-out;
  position: relative;
  .offline_item_content {
    height: 240px;
    position: relative;
    overflow: hidden;
    .dong {
      width: 100%;
      height: 100%;
      border-radius: 0 0 10px 10px;
      transition: all 2s;
      z-index: 11;
    }
    .dong:hover {
      transform: scale(1.5);
      border-radius: 0 0 10px 10px;
    }
    .active {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      border-radius: 0 0 10px 10px;
      background: rgba(0, 0, 0, 0.4);
    }
    .text_box {
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      height: 100%;
      color: #fff;
      padding: 130px 20px 40px 20px;
      box-sizing: border-box;
      font-size: 14px;
    }
  }
  .offline_item_top {
    border-bottom: 1px solid #fff;
    padding: 30px 0 20px 0;
    box-sizing: border-box;
    border-radius: 10px 10px 0 0;
    width: 100%;
    text-align: center;
    color: #ffffff;
    .title {
      font-size: 24px;
      font-weight: bold;
      margin-bottom: 10px;
    }
    .content {
      font-size: 14px;
    }
    // background: linear-gradient(90deg, #1f8ffb, #0f54ec);
  }
  // .hide {
  //   width: 100%;
  //   height: 100%;
  //   padding: 50px;
  //   border-radius: 10px;
  //   box-sizing: border-box;
  //   background: rgba(0, 0, 0, 0.4);
  //   color: #fff;
  //   display: flex;
  //   align-items: center;
  //   text-align: center;
  //   justify-content: center;
  //   font-size: 30px;
  // }
  // .show {
  //   position: absolute;
  //   bottom: 0;
  //   left: 0;
  //   width: 100%;
  //   height: 100%;
  //   background: rgba(255, 0, 0, 0.6);
  //   border-radius: 10px;
  //   padding: 30px;
  //   box-sizing: border-box;
  //   color: #fff;
  // }
}
.offline_item:nth-child(4) {
  margin-right: 0;
}
</style>